import { useMemo } from 'react';
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { CHART_COLORS, formatChartTooltipValue } from '../../chartUtils';
import { useInspectorPerformanceQuery } from '../../hooks/useDashboardAnalytics';
import { ChartCard } from './ChartCard';

type InspectorPerformanceChartProps = {
  regionalCode: string;
};

export function InspectorPerformanceChart({ regionalCode }: InspectorPerformanceChartProps) {
  const { data, isLoading, errorMessage } = useInspectorPerformanceQuery(regionalCode);

  const chartData = useMemo(
    () =>
      (data?.items ?? [])
        .slice()
        .sort((a, b) => b.completed - a.completed)
        .map((item) => ({
          name: item.teaInspectorName,
          completed: item.completed,
        })),
    [data]
  );

  return (
    <ChartCard
      title="Inspector Performance"
      subtitle="All inspectors — national"
      loading={isLoading}
      error={errorMessage}
      minHeight={360}
    >
      {chartData.length > 0 ? (
        <ResponsiveContainer width="100%" height={360}>
          <BarChart data={chartData} margin={{ top: 8, right: 16, left: 0, bottom: 48 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="name"
              interval={0}
              angle={-35}
              textAnchor="end"
              height={70}
              tick={{ fontSize: 11 }}
            />
            <YAxis />
            <Tooltip formatter={(value) => formatChartTooltipValue(value)} />
            <Bar
              dataKey="completed"
              name="Completed"
              fill={CHART_COLORS.inspector}
              radius={[4, 4, 0, 0]}
            />
          </BarChart>
        </ResponsiveContainer>
      ) : null}
    </ChartCard>
  );
}
